import React from "react";
import syncIcon from "../assets/images/sync-icon-green.svg";
import loadingIcon from "../assets/images/loadingIcon.svg";
import errorIcon from "../assets/images/sync-error-icon.svg";

const statusConfig = {
  Synced: {
    backgroundColor: "#E3FCEF",
    color: "#0E8345",
    icon: syncIcon,
  },
  "Basic Tracking": {
    backgroundColor: "#E3FCEF",
    color: "#0E8345",
    icon: '', // Change if you have a better icon
  },
  "Checking Credentials": {
    backgroundColor: "#F3F3F3",
    color: "#5E5E5E",
    icon: loadingIcon,
  },
  "Incorrect Credentials": {
    backgroundColor: "#FFF0EE",
    color: "#D32F2F",
    icon: errorIcon,
  },
  Default: {
    backgroundColor: "#F3F3F3",
    color: "#000",
    icon: loadingIcon,
  },
};

const StatusTag = ({ status }) => {
  // Normalize the incoming status
  let mappedStatus = status;
  if (status === "Connected" || status === "linked") mappedStatus = "Synced";
  else if (status === "error") mappedStatus = "Incorrect Credentials";
  else if (status === "basic") mappedStatus = "Basic Tracking";
  else if(status === "pending") mappedStatus = "Checking Credentials"

  // Pick from config or fallback
  const { backgroundColor, color, icon } = statusConfig[mappedStatus] || statusConfig["Checking Credentials"];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 12px",
        borderRadius: "4px",
        backgroundColor,
        color,
        fontSize: "10px",
        fontWeight: "600",
        width: "max-content",
      }}
    >
      {icon && (
        <img
          src={icon}
          alt={mappedStatus}
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      )}
      {mappedStatus}
    </span>
  );
};

export default StatusTag;
